import { useCallback, useContext } from "react";
import useTranslate from "hooks/useTranslate";
import MessageDialogContext from "context/MessageDialogContext";
import checkPosTaxLinkValidity, {
  PosTaxLinkInvalidReason,
} from "./checkPosTaxLinkValidity";
import useStoreDetailsIssueDialog from "./useStoreDetailsIssueDialog";

export default function usePosTaxLinkGuard() {
  const showStoreDetailsIssue = useStoreDetailsIssueDialog();
  const { translate: taxTranslate } = useTranslate("admin.taxes");
  const { translate: posTranslate } = useTranslate("admin.pos");
  const { setActionCloseMessageInfo } = useContext(MessageDialogContext);

  const showSyriaStationIssue = useCallback(() => {
    setActionCloseMessageInfo(
      taxTranslate("storeNotLinkedToStationTitle"),
      taxTranslate("storeNotLinkedToStationBody"),
      "close",
    );
  }, [setActionCloseMessageInfo, taxTranslate]);

  const showEgyptDeviceIssue = useCallback(() => {
    setActionCloseMessageInfo(
      posTranslate("posNotLinkedToDeviceHeaderMessage"),
      posTranslate("posNotLinkedToDeviceMessage"),
      "close",
    );
  }, [posTranslate, setActionCloseMessageInfo]);

  const showIssue = useCallback(
    (reason?: PosTaxLinkInvalidReason) => {
      if (reason === "syriaStation") showSyriaStationIssue();
      else if (reason === "egyptDevice") showEgyptDeviceIssue();
      else showStoreDetailsIssue();
    },
    [showEgyptDeviceIssue, showStoreDetailsIssue, showSyriaStationIssue],
  );

  const ensureStoreIsValid = useCallback(
    async (posId?: string | null) => {
      const result = await checkPosTaxLinkValidity(
        posId ?? localStorage.getItem("posId"),
      );
      if (!result.isValid) showIssue(result.reason);
      return result.isValid;
    },
    [showIssue],
  );

  return {
    ensureStoreIsValid,
    showStoreDetailsIssue,
    showSyriaStationIssue,
    showEgyptDeviceIssue,
  };
}
